const getAllAccountsResponse = (response) => {
  return response?.accountLivestreams.map((account) => {
    return {
      value: account?.id,
      label: account?.name,
      ecommerceName: account.ecommerce.name,
      brandName: account?.brands?.[0]?.name || '',
    };
  });
};

export default getAllAccountsResponse;
